



































import { routeHelper } from '../../utils/routeHelper';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonCalendar, { CalendarEvent, DateClickEvent, DatesRenderEvent, LessonStatesColor } from '../../components/organisms/CommonCalendar.vue';
import { Session } from '../../utils/Session';
import { dayjs, DT_FORMAT } from '../../../src_server/common/momentExtends';
import { MessageDialog } from '../../utils/MessageDialog';
import { LessonsService } from '../../biz/remote/LessonsService';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import LessonResevationCommitDialog from './LessonResevationCommitDialog.vue';
import TransferIcon from '../../components/icon/TransferIcon.vue';

@Component({ components: { CommonCalendar, LessonResevationCommitDialog, TransferIcon } })
export default class LessonReservationCommitCalendarPage extends Vue {
  private lessonList: CalendarEvent[] = [];
  public origin: LessonDTO[] = [];

  /**
   * すでに置かれたイベントをクリックした時
   */
  async eventClick(e: DateClickEvent) {
    const event = (e as any).event;
    const id: number = event.id;

    const foundDTO = this.origin.find((dto) => {
      // idが文字列なので、===ではなく==
      return dto.lessons.class_id == id;
    });
    console.log(id, this.origin, foundDTO);

    if (!foundDTO) {
      await MessageDialog.systemError('レッスンデータオブジェクト', 'レッスン予約のカレンダーのイベントをクリックした時', foundDTO);
      return;
    }
    (this.$refs['LessonResevationCommitDialog'] as LessonResevationCommitDialog).show(foundDTO!);
  }

  /**
   * LessonDTOからカレンダーイベントへ変換
   */
  convertCalendarEventFromLessonDTO(dto: LessonDTO): CalendarEvent {
    const date = dto.lessons.start_dt;
    const nickname = dto.student?.nickname;
    const lesson_id = dto.lessons.class_id;
    const state = dto.lessons.reservation_state!;

    // レッスン状態によって色を分ける
    let color = LessonStatesColor.getColor(state);

    const title = `${nickname} ${state}`;

    const event = {
      title: title,
      start: dayjs(date).format(DT_FORMAT),
      end: dayjs(date).add(1, 'hour').format(DT_FORMAT),
      backgroundColor: color,
      type: 'request',
      id: lesson_id,
    } as CalendarEvent;
    return event;
  }

  /**
   * 表示している領域が変更になった時
   */
  async datesRender(event: DatesRenderEvent, el: any) {
    console.log(event.view);
    const start = dayjs(event.view.activeStart).format(DT_FORMAT);
    const end = dayjs(event.view.activeEnd).format(DT_FORMAT);

    const biz = new LessonsService();
    const response = await biz.getRequestedLessonsForTeacherBetween(Session.getSessionUserId(), start, end);
    if (response.hasError) {
      MessageDialog.alert(response.errorDescription);
      return;
    }
    this.origin = response.data;
    this.lessonList = this.origin.map((l) => {
      return this.convertCalendarEventFromLessonDTO(l);
    });
  }

  /**
   * 確定処理
   */
  private commit(dto: LessonDTO) {
    this.lessonList = this.origin
      .filter((i) => {
        i.lessons !== dto.lessons.class_id;
      })
      .map((l) => {
        return this.convertCalendarEventFromLessonDTO(l);
      });
  }

  toListView() {
    routeHelper(this, 'LessonReservationCommitPage');
  }
}
